import React from 'react';
import styled from 'styled-components';
import { Form } from 'react-final-form';
import { CardActionsContainer } from '../../styles/CardTextAndContainers';
import {
  IAppState,
  IGridQuestionGroup,
  IQuestion,
  IQuestionGroup,
  IUserFormInput,
} from '../../types';
import { AppDispatch } from '../../reducers/appReducer';
import NavigationButtons from '../NavigationButtons';
import GridQuestionGroup from '../questions/GridQuestion/GridQuestionGroup';
import Question from '../questions/Question';

interface IProps {
  submitHandler: (userInput: IUserFormInput) => void;
  cardData: IQuestionGroup | IGridQuestionGroup;
  state: IAppState;
  dispatch: AppDispatch;
}

const QuestionForm = ({ submitHandler, cardData, state, dispatch }: IProps) => {
  return (
    <Form onSubmit={submitHandler}>
      {({ handleSubmit }) => (
        <StyledForm onSubmit={handleSubmit}>
          {cardData.grid ? (
            <GridQuestionGroup questionGroup={cardData} />
          ) : (
            cardData.questions.map((question: IQuestion) => (
              <Question key={`${question.id}`} question={question} />
            ))
          )}
          <CardActionsContainer>
            <NavigationButtons state={state} dispatch={dispatch} />
          </CardActionsContainer>
        </StyledForm>
      )}
    </Form>
  );
};

const StyledForm = styled.form`
  padding-top: 15px;
`;

export default QuestionForm;
